var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pa-6 d-flex flex-row justify-center align-center stripes fill-height"},[_c('Login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }